

import { Flex } from 'antd';

export default function FeaturedHeader() {
    return <Flex className='featured_header' justify='space-between'>
        <Flex className='featured_header_name'>Featured Categories</Flex>
        <Flex className='featured_cate' algin="center">
            <div className='featured_cate_item'>
                <div className='featured_cate_item_title'>2.1 million</div>
                <div className='featured_cate_item_cont'>Products</div>
            </div>
            <div className='featured_cate_item'>
                <div className='featured_cate_item_title'>75,000+</div>
                <div className='featured_cate_item_cont'>Suppliers</div>
            </div>
            <div className='featured_cate_item'>
                <div className='featured_cate_item_title'>1000+</div>
                <div className='featured_cate_item_cont'>Categories</div>
            </div>
            <div className='featured_cate_item'>
                <div className='featured_cate_item_title'>20+</div>
                <div className='featured_cate_item_cont'>Industries</div>
            </div>
        </Flex>
    </Flex>
}